module.exports = __webpack_public_path__ + "media/images/img_service_merit_3_2-7c1871a95759eda4b146d704c36b10d0.png";